import { AxiosResponse } from "axios";
import { useUserStore } from "@/store/user";
import { useSocietyStore } from "@/store/society";
import { syncUserLocale } from "@/utils/userLocale";

export const loadTenantConfig = (response: AxiosResponse) => {
  const userStore = useUserStore();
  const societyStore = useSocietyStore();

  const permissions: string[] = Array.isArray(response.data.permissions) ? response.data.permissions : []
  const hasBudget = permissions.includes("HAS_BUDGET")
  const hasLineRelations = permissions.includes("HAS_LINE_RELATIONS")
  const hasAi = permissions.includes("HAS_AI")
  const hasAdvancedQuotations = permissions.includes("HAS_ADVANCED_QUOTATIONS")

  userStore.setUser(response.data.user);
  userStore.homeBlocks = Array.isArray(response.data.home_blocks) ? response.data.home_blocks : [];
  syncUserLocale(response.data.user);
  societyStore.setPlan(response.data.plan);
  societyStore.setName(response.data.society_name);
  societyStore.setPaymentStatus(response.data.payment_status);
  societyStore.setHasTransactions(response.data.has_transactions);
  societyStore.setHasErpConnection(response.data.has_erp_connection);
  societyStore.setHasAi(hasAi);
  societyStore.setHasBudget(hasBudget);
  societyStore.setHasLineRelations(hasLineRelations);
  societyStore.setHasAdvancedQuotations(hasAdvancedQuotations);
  societyStore.setPermissions(permissions);
  societyStore.setCountry(response.data.country);
  societyStore.setTimezone(response.data.timezone || "");
  societyStore.setErp(response.data.erp);
  societyStore.setIsConsolidated(response.data.is_consolidated || false);
  societyStore.setCompanyId(response.data.company_id || 0);
  societyStore.setContentLanguage(response.data.content_language || "es");
  societyStore.setEnabledLanguages(response.data.enabled_languages || []);
  societyStore.setCompanySocieties(response.data.company_societies || []);
  societyStore.setFirewallEnabled(response.data.auto_run || false);
  // Derived boolean computed by the backend (RiskProviderConfig.enabled by country).
  // Direct mutation instead of a setX action per the store migration rule.
  societyStore.hasExternalRisk = response.data.has_external_risk ?? false;
  // Same shape: derived by the backend (country engine + society switch), not permissions.
  societyStore.fintaxAvailable = response.data.fintax_available ?? false;
  societyStore.fintaxEnabled = response.data.fintax_enabled ?? false;
  societyStore.splitManualPaymentsByCostCenter = response.data.split_manual_payments_by_cost_center ?? false;
}
